module.exports = "https://static-www.niulinkcloud.com/_next/static/media/pcBg.1081a170dad2803fd59751e8210f659b.png";